import React, { Component } from 'react';

import swal from 'sweetalert2';
import axios from 'axios/index';
import { withRouter } from 'react-router-dom';

import urls from '../../../../../utils/urls';
import { ajaxHandler } from '../../../../../utils/errors';
import { tokenHeader } from '../../../../../utils/headers';
import translator from '../../../../../utils/translations';
import ToggleInput from "../../../../../components/ToggleInput/toggleInput";
import DischargeAudit from "./DischargeAudit";
import helpers from "../../../../../utils/helpers";
import formatters from "../../../../../utils/formatters";


class DischargeInput extends Component {

    constructor (props) {
        super(props);

        this.state = {
            canEdit: true, //helpers.isUserProvider(props.user),
            ajaxInProgress: false,
            trip: props.trip,
            meters: props.meters,
            discharge: props.discharge,
            showAudit: false,
            edited: false,

            // Fields
            meter_works: true,
            compartments_check: null,
            final_totalizer: '',
            unload_observations: ''
        }
    }


    _handleInput = (prop, value) => {

        // Custom validations

        this.setState({[prop]: value, edited: true})
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value, edited: true});
    };

    _submitForm = () => {
        let {final_totalizer, unload_observations, compartments_check, meter_works} = this.state;

        if(meter_works){
            if(!final_totalizer || final_totalizer <= this.state.discharge.initial_totalizer || !compartments_check){
                swal({
                    title: 'Error',
                    html: '<div class=\'swal-container\'><p>Por favor, controle todas las cisternas, ingrese el valor final del meter y asegúrese de que sea mayor al inicial</p></div>',
                    type: 'error'
                });
                return false
            }
        }else{
            if(!compartments_check){
                swal({
                    title: 'Error',
                    html: '<div class=\'swal-container\'><p>Por favor, controle todas las cisternas para continuar</p></div>',
                    type: 'error'
                });
                return false
            }
        }
        this.setState({ajaxInProgress: true});

        let data = {meter_works, unload_observations, compartments_check, finished_discharge: true};
        if(meter_works){
            data['final_totalizer'] = final_totalizer;
        }

        const DISCHARGE_URL = `${urls.API_ROOT}/api/v1/discharge/id/${this.state.discharge.id}/`;
        axios.put(`${DISCHARGE_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError)

    };

    _onSubmitSuccess = (response) => {
        swal({
            title: 'Descarga completa',
            html: 'La descarga se ha ingresado correctamente. ' +
            'Usted ahora puede enviar el viaje a la balanza de salida o ingresar una nueva descarga. ' +
            'Por favor, elija una opción',
            type: 'success',
            showConfirmButton: true,
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Enviar a Balanza',
            cancelButtonText: 'Nueva Descarga',
            preConfirm: this.props.closeDischarge,
            reverseButtons: true
        }).then((result) => {
            if (result.dismiss === swal.DismissReason.cancel) {
                this.props.reloadTrip();
            }
        });
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false})
        try {
            let response = error.response;
            if (response.status === 400) {
                let keys = Object.keys(response.data);
                let details = '';
                for (let i in keys) {
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido guardar la descarga',
                    html: body,
                    type: 'error'
                });
            } else {
                ajaxHandler(error);
            }
        }
        catch (e) {
            ajaxHandler(error);
        }
    };

    _goBack = () => {
        if(this.state.edited){
            swal({
                title: 'Atención',
                html: helpers.texts.editionWarning,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Volver al inicio',
                cancelButtonText: 'Cancelar',
                preConfirm: () => this.props.history.push('/'),
                reverseButtons: true
            });
        }else{
            this.props.history.push('/')
        }
    };

    render () {
        let {trip, discharge} = this.state;
        if (!trip || !discharge) return <div/>;

        // If there's an ajax call in progress or if user can not edit
        let disableButtons = (this.state.ajaxInProgress || !this.state.canEdit);

        // Show Audit button?
        let showAudit = (this.state.meter_works !== false && discharge.can_be_audited);

        return (
            <div>
                <div className={'discharge-title-section margin-bottom-5'}>
                    <i className={"material-icons icon-check"}>check</i>
                    Controles Previos
                </div>
                <div className={'discharge-title-section margin-bottom-5'}>
                    <i className={"material-icons icon-check"}>check</i>
                    Meter seleccionado
                    <div className={"meter-detail"}>{discharge.meter.loading_island.name} - {discharge.meter.description}</div>
                </div>
                <div className={'discharge-title-section no-margin'}>Descarga</div>
                <div className={'row thin-row'}>
                    <div className={"col s6"}>
                        <ToggleInput
                            selected={this.state.meter_works} className={"no-border no-margin"}
                            name={'Meter funcionando'} stateVar={'meter_works'}
                            toggleAction={this._handleToggle}
                        />
                    </div>
                </div>
                <div className={`row ${this.state.meter_works === false ? "disabled-boxes" : ''} no-margin`}>
                    <div className={'col s6'}>
                        <div className={'meter-box'}>
                            <div className={'meter-box-title'}>
                                <i className={"material-icons"}>play_circle_outline</i>
                                <div>Inicio</div>
                            </div>
                            <div className={'row no-margin meter-box-body'}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Inicio - Meter</label>
                                    <p className={"field-p"}>
                                        {formatters.intFormat(discharge.initial_totalizer)}
                                        {showAudit &&
                                        <i className={'pointer material-icons'}
                                           style={{position: 'absolute', right: '15px', top: '10px'}}
                                           onClick={() => this.setState({showAudit: true})}>
                                            edit
                                        </i>
                                        }
                                    </p>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Hora de inicio</label>
                                    <p className={"field-p"}>
                                        {discharge.unload_started_at}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'col s6'}>
                        <div className={'meter-box'}>
                            <div className={'meter-box-title'}>
                                <i className={"material-icons"}>pause_circle_outline</i>
                                <div>Fin descarga</div>
                            </div>
                            <div className={'row no-margin meter-box-body'}>
                                <div className={"col s12 input-field input-grey"}>
                                    <label className="active">Fin - Meter</label>
                                    {this.state.meter_works === false ?
                                        <p className={"field-p"}>-</p> :
                                        <input placeholder={"Ingrese un valor"} value={this.state.final_totalizer} type={"number"}
                                               onChange={(ev) => this._handleInput('final_totalizer', ev.target.value)}
                                               className={"no-margin"}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'row no-margin'}>
                    <div className={"col s6"}>
                        <ToggleInput
                            selected={this.state.compartments_check} className={"no-border no-margin"}
                            name={'¿Se vaciaron todas las cisternas?'} stateVar={'compartments_check'}
                            toggleAction={this._handleToggle}
                        />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field input-grey"}>
                        <label className="active">Observaciones de la descarga</label>
                        <textarea
                            className={"materialize-textarea dispatch-textarea"} rows={4}
                            onChange={(ev) => this._handleInput('unload_observations', ev.target.value)}
                            defaultValue={this.state.unload_observations}
                        />
                    </div>
                </div>
                <div className={'row center'}>
                    <div className={'col s12'}>
                        <button onClick={this._goBack}
                              className={`btn btn-shell-empty z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Volver
                        </button>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Finalizar Descarga
                        </button>
                    </div>
                </div>
                {this.state.showAudit &&
                    <DischargeAudit trip={trip} discharge={discharge}
                                    reloadTrip={this.props.reloadTrip}
                                    closeAudit={() => this.setState({showAudit: false})}
                    />
                }
            </div>
        )
    }
}

export default withRouter(DischargeInput);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Discharge/DischargeInput.js